<template>
  <main>
    <v-dialog v-model="deleteDialog" max-width="420px">
      <DeleteModal
          title="Deletar"
          textMessage="Tem certeza que quer remover esta promoção?"
          cancelBtn="Cancelar"
          okbtn="Remover"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(deleteDialog = false)"
          @action="remove"
      />
    </v-dialog>

    <v-dialog
        v-model="addResalesDialog" max-width="700px"
        :loading="loading"
    >
      <v-card
          width="100%"
          elevation="0"
      >
        <v-toolbar
            elevation="0"
            color="#bc0000"
            dark
        >
          <h2>Adicionar revendas a promoção</h2>
        </v-toolbar>

        <v-list
            two-line
            subheader
        >
          <h3 v-if="resales.length > 0" class="ml-5 mt-4 mb-2 text-center">Selecione as revenda para adicionar a promoção</h3>
          <h3 v-else class="ml-5 mt-7 mb-5 text-center">Todas as revendas cadastrar na plataforma já estão adicionadas na promoção</h3>
        </v-list>

        <v-divider></v-divider>

        <v-list
            v-model="resales"
            v-for="(resale, index) in resales"
            :key="`${index}-${resale.id}`"
            multiple
        >
          <v-list-item>
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox
                    v-model="resale.checked"
                    :input-value="active"
                    :key="index"
                    color="primary"
                    large
                ></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ resale.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
          <v-divider v-if="index < resales.length - 1"></v-divider>
        </v-list>

        <v-row class=" ma-0 pa-0">
          <v-col cols="12" class="d-flex justify-center pl-7">
            <v-btn
                elevation="0"
                large
                class="cancel-button black--text mr-3"
                @click="closeResaleAddedPromotionDialog()"
                outlined
                height="45"
            >
              <span>Cancelar</span>
            </v-btn>

            <v-btn
                elevation="0"
                large
                :disabled="resalesIsempty"
                class="cadaster-button white--text"
                color="normalred"
                @click="addResalesPromotion()"
                :loading="loading"
                height="45"
            >
              <span>Adicionar revendas</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="deleteResalesDialog" max-width="700px"
        :loading="loading"
    >
      <v-card
          width="100%"
          elevation="0"
      >
        <v-toolbar
            elevation="0"
            color="#bc0000"
            dark
        >
          <h2>Excluir revendas da promoção</h2>
        </v-toolbar>

        <v-list
            two-line
            subheader
        >
          <h3 class="ml-5 mt-4 mb-2 text-center">Selecione as revenda que serão excluídas da promoção</h3>
        </v-list>

        <v-divider></v-divider>

        <v-list
            v-model="resalesDelete"
            v-for="(resale, index) in resalesDelete"
            :key="`${index}-${resale.id}`"
            multiple
        >
          <v-list-item>
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox
                    v-model="resale.checked"
                    :input-value="active"
                    :key="index"
                    color="primary"
                    large
                ></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ resale.resale.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
          <v-divider v-if="index < resalesDelete.length - 1"></v-divider>
        </v-list>

        <v-row class=" ma-0 pa-0">
          <v-col cols="12" class="d-flex justify-center pl-7">
            <v-btn
                elevation="0"
                large
                class="cancel-button black--text mr-3"
                @click="closeDeleteResalesDialog()"
                outlined
                height="45"
            >
              <span>Cancelar</span>
            </v-btn>

            <v-btn
                elevation="0"
                large
                class="cadaster-button white--text"
                color="normalred"
                @click="deleteResalesPromotion()"
                :disabled="resalesDeleteIsempty"
                :loading="loading"
                height="45"
            >
              <span>Excluir revendas</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="resalesAddedDialog" max-width="700px"
        :loading="loading"
    >
      <v-card
          width="100%"
          elevation="0"
      >
        <v-toolbar
            elevation="0"
            color="#bc0000"
            dark
        >
          <h2>Revendas Adicionadas na promoção</h2>
        </v-toolbar>
        <ul
            v-for="(resale, index) in resaleAddedPromotion"
            :key="`${index}-${resale.id}`"
            multiple
        >
          <li class="py-3 ml-4" style="font-size: 16px">
            {{ resale.resale.name }}
          </li>
          <v-divider v-if="index < resaleAddedPromotion.length - 1"></v-divider>
        </ul>

        <v-row class=" ma-0 pa-0">
          <v-col cols="12" class="d-flex justify-center pl-7">
            <v-btn
                elevation="0"
                large
                class="cancel-button black--text mr-3"
                @click="closeAddResalesDialog()"
                outlined
                height="45"
                width="100%"
            >
              <span>Fechar</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>


    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="actionSelected"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === actionSelected).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="performAction()"
      />
    </v-dialog>


    <Header
        buttonTitle="Criar promoção"
        title="Central de Promoções"
        text="Promoções cadastradas"
        @action2="goToRoute('/promotion')"
        :haveAction="false"
        :haveBack="false"
        :haveCustomButton="true"
    />

    <v-card
        transition="scale-transition"
        class="d-column mt-2 mx-2 py-4"
        elevation="1"
        color="#FFFFFF"
        style="border-radius: 6px"
    >
      <v-row class="ma-0 justify-space-between px-1">
        <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            class="pa-2"
        >
          <v-text-field
              v-model="filter.name"
              outlined
              dense
              placeholder="Digite o nome da promoção"
              label="Nome da promoção"
              height="45"
              hide-details="auto"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            class="pa-2"
        >
          <v-select
              :loading="loading"
              hide-details
              dense
              height="45"
              full-width
              outlined
              placeholder="Selecione o tipo de desconto"
              label="Tipo de desconto"
              :items="discountTypes"
              item-text="label"
              item-value="value"
              v-model="filter.discountType"
          >
            <template v-slot:selection="{ item }">
              <span class="normal">{{ item.label }}</span>
            </template>
          </v-select>
        </v-col>

        <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            class="pa-2"
        >
          <v-text-field
              v-model="filter.discountStart"
              outlined
              dense
              height="45"
              type="number"
              placeholder="Digite o desconto inicial"
              label="Desconto inicial"
              hide-details="auto"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            class="pa-2"
        >
          <v-text-field
              v-model="filter.discountEnd"
              outlined
              dense
              height="45"
              type="number"
              placeholder="Digite o desconto final"
              label="Desconto final"
              hide-details="auto"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ma-0 justify-space-between px-1 mt-1">
        <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            class="pa-2"
        >
          <v-text-field
              v-model="filter.dateStart"
              outlined
              dense
              height="45"
              type="date"
              placeholder="Digite a data inicial"
              label="Data inicial"
              hide-details="auto"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            class="pa-2"
        >
          <v-text-field
              v-model="filter.dateEnd"
              outlined
              dense
              height="45"
              type="date"
              placeholder="Digite o data final"
              label="Data final"
              hide-details="auto"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            class="pa-2"
        >
          <v-select
              :loading="loading"
              hide-details
              height="45"
              dense
              full-width
              outlined
              placeholder="Selecione o status da promoção"
              label="Status da promoção"
              :items="statusFilter"
              item-text="label"
              item-value="value"
              v-model="filter.status"
          >
            <template v-slot:selection="{ item }">
              <span class="normal">{{ item.label }}</span>
            </template>
          </v-select>
        </v-col>

        <v-col
            cols="12"
            sm="6"
            md="3"
            lg="3"
            class="pa-2"
        >
          <v-select
              outlined
              :items="regions"
              hide-details
              dense
              height="45"
              v-model="filter.region"
              placeholder="Selecione a regição"
              label="Região"
              required
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="ma-0 justify-space-between px-1 mt-1">
        <v-col
            cols="12"
            sm="6"
            md="6"
            lg="6"
            class="pa-2"
        >
          <v-autocomplete
              v-model="filter.products"
              multiple
              outlined
              dense
              min-height="45"
              item-text="productName"
              item-value="productId"
              hide-details="auto"
              placeholder="Selecione os produtos"
              label="Produtos"
              menu-props="auto"
              :items="products"
          ></v-autocomplete>
        </v-col>

        <v-col
            cols="12"
            sm="6"
            md="6"
            lg="6"
            class="pa-2"
        >
          <v-autocomplete
              v-model="filter.resales"
              multiple
              outlined
              dense
              min-height="45"
              item-text="name"
              item-value="id"
              hide-details="auto"
              placeholder="Selecione as revendas"
              label="Revendas"
              menu-props="auto"
              :items="resalesFiltes"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row justify="end" class="ma-0 justify-space-between px-1 mt-1">
        <v-col
            cols="12"
            sm="6"
            md="6"
            lg="6"
            class="px-2 d-flex justify-space-between"
        >
        </v-col>

        <v-col
            cols="12"
            sm="6"
            md="6"
            lg="6"
            class="px-2 d-flex justify-space-between"
        >
          <v-btn
              outlined
              width="49%"
              style="border-radius: 8px!important;"
              large
              height="45"
              @click="list()"
          >
            Buscar
          </v-btn>

          <v-btn
              outlined
              width="49%"
              style="border-radius: 8px!important;"
              large
              height="45"
              dense
              @click="resetFilter()"
          >
            Limpar filtros
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="mx-2">
      <v-row cols="12">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="items"
              class="content-table"
              loading-text="Buscando..."
              no-data-text="Sem registros"
              hide-default-footer
              v-model="selectedPromotions"
              show-select
              item-key="id"
              :single-select="false"
          >
            <template v-slot:[`item.discountType`]="{ item }">
              {{ item.discountType === 1 ? 'Percentual' : 'Real' }}
            </template>

            <template v-slot:[`item.discount`]="{ item }">
              {{
                item.discountType === 1 ? `${item.discount} %` : item.discount.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>

            <template v-slot:[`item.start`]="{ item }">
              {{ item.end ? formatDate(item.start) : 'Sem registro' }}
            </template>

            <template v-slot:[`item.end`]="{ item }">
              {{ item.end ? formatDate(item.end) : 'Sem registro' }}
            </template>

            <template v-slot:[`item.promotionProducts`]="{ item }">
              {{ item.promotionsProduct.length }}
            </template>

            <template v-slot:[`item.promotionResales`]="{ item }">
              {{ item.promotionsResale.length }}
            </template>

            <template v-slot:[`item.active`]="{ item }">
              <div class="d-flex pa-0 ma-0">
                <v-select
                    :loading="loading"
                    class="ma-3 pa-0 update-status"
                    hide-details
                    dense
                    outlined
                    :items="status"
                    @change="changeStatus(item)"
                    item-text="label"
                    item-value="value"
                    v-model="item.active"
                >
                  <template v-slot:selection="{ item }">
                    <span class="normal">{{ item.label }}</span>
                  </template>
                </v-select>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <div style="display: flex; flex-direction: row; flex-wrap: nowrap">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px"
                        width="35"
                        height="35"
                        small
                        :disabled="!(item.promotionsResale && item.promotionsResale.length > 0)"
                        class="ma-1 quinary-button"
                        color="quaternary"
                        @click="showshowResaleAddedPromotionDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver revendas adicionas</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px"
                        width="35"
                        height="35"
                        small
                        class="ma-1 quinary-button"
                        color="quaternary"
                        @click="showAddResalesDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar revendas</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px"
                        width="35"
                        height="35"
                        small
                        :disabled="!(item.promotionsResale && item.promotionsResale.length > 0)"
                        class="ma-1 quinary-button"
                        color="quaternary"
                        @click="showDeleteResalesDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir revendas</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px"
                        width="35"
                        height="35"
                        small
                        class="ma-1 quinary-button"
                        color="quaternary"
                        @click="editPromotion(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px"
                        width="35"
                        height="35"
                        small
                        class="ma-1 remove-button"
                        color="red"
                        @click="deletePromotion(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:header.data-table-select="{ on, props}">
              <v-simple-checkbox
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
                  :ripple="false"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
              <v-simple-checkbox
                  :ripple="false"
                  @click="addPromotionListSelectedPromotions(item)"
                  :value="isSelected"
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:footer >
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="filter.totalItems > filter.pageSize"
                    :currentPage="filter.currentPage"
                    :totalItems="filter.totalItems"
                    :page="filter.page"
                    :pageSize="filter.pageSize"
                    :totalPages="filter.totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>

              <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedPromotions.length > 0">
                <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
                  <label>Selecione a ação</label>
                  <v-select
                      class="ma-0 pa-0 "
                      dense
                      v-model="actionSelected"
                      outlined
                      style="border-radius: 3px!important"
                      :items="actions"
                      item-text="label"
                      item-value="value"
                      placeholder="Selecione a ação"
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 mt-2">
                  <v-btn
                      class="secondary-button mt-5 ml-3"
                      style="height: 40px!important; border-radius: 7.5px!important"
                      height="40"
                      width="100%"
                      elevation="0"
                      :disabled="!actionSelected"
                      @click="confirmActionDialog = true"
                  >
                    {{ actionSelected ? actions.find((x) => x.value === actionSelected).label : 'Selecione a ação'}}
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </main>
</template>

<script lang="js">
import ApiService from '../../../services/ApiService';
import Header from "./components/Header";
import Utils from "../../../Utils/FormatDate";
import DeleteModal from "../components/DeleteModal";
import Vue from "vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "PromotionsCenter",
  components: {
    ConfirmModal,
    Pagination,
    Header,
    DeleteModal
  },
  async created() {
    await this.list()
    this.resalesFiltes = await this.getResales()
    await this.getProducts()
  },

  data() {
    return {
      selectedPromotions: [],
      actions: [
        { label: "Ativar promoção(s)", value: 1},
        { label: "Inativar promoção(s)", value: 2},
        { label: "Excluir promoção(s)", value: 3},
      ],
      actionSelected: null,
      confirmActionDialog: false,
      loading: false,
      resalesAddedDialog: false,
      apiService: new ApiService(),
      filter: {
        name: null,
        discountType: null,
        discountStart: null,
        discountEnd: null,
        dateStart: null,
        dateEnd: null,
        status: null,
        region: null,
        resales: [],
        products: [],
        pageSize: 20,
        page: 1,
        totalPages: 1,
        totalItems: 1,
        currentPage: 1,
      },
      headers: [
        {
          text: "Nome",
          value: "name",
          sortable: false,
          align: "center",
        },
        {
          text: "Tipo de desconto",
          value: "discountType",
          sortable: false,
          align: "center",
        },
        {
          text: "Desconto",
          value: "discount",
          sortable: false,
          align: "center",
        },
        {
          text: "Início",
          value: "start",
          sortable: false,
          align: "center",
        },
        {
          text: "Fim",
          value: "end",
          sortable: false,
          align: "center",
        },
        {
          text: "Status",
          value: "active",
          sortable: false,
          align: "center",
        },
        {
          text: "Produtos",
          value: "promotionProducts",
          sortable: false,
          align: "center",
        },
        {
          text: "Revendas",
          value: "promotionResales",
          sortable: false,
          align: "center",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      resaleAddedPromotion: [],
      items: [],
      resales: [],
      resalesFiltes: [],
      products: [],
      resalesDelete: [],
      resalesSelected: [],
      settings: [],
      currentPromotion: null,
      deleteDialog: false,
      deleteResalesDialog: false,
      addResalesDialog: false,
      status: [
        {label: "Inativo", value: false},
        {label: "Ativo", value: true},
      ],
      statusFilter: [
        {label: "Inativo", value: 1},
        {label: "Ativo", value: 2},
      ],
      discountTypes: [
        {label: "Percentual", value: 1},
        {label: "Real", value: 2},
      ],
      regions: [
        "Nacional - Todas as Regiões",
        "Internacional",
        "Sul - Região 5",
        "Sudeste - Região 4",
        "Centro-Oeste - Região 3",
        "Nordeste - Região 2",
        "Norte - Região 1",
      ],
    }
  },

  computed: {
    resalesIsempty() {
      return !this.resales.find(x => x.checked)
    },
    resalesDeleteIsempty() {
      return !this.resalesDelete.find(x => x.checked)
    },
  },
  methods: {
    performAction(){
      this.confirmActionDialog = false;
      switch (this.actions.find((x) => x.value === this.actionSelected).label) {
        case 'Ativar promoção(s)':
        case 'Inativar promoção(s)':
          this.updateStatusPromotions()
          break
        default:
          this.removePromotions()
      }
    },

    updateStatusPromotions(){
      try {
        const selectedPromotions = JSON.parse(JSON.stringify(this.selectedPromotions))
        selectedPromotions.forEach((promotion) => {
          promotion.active = this.actionSelected === 1;
        })

        this.apiService.put('promotion/active/list', selectedPromotions).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Promoções atualizadas com sucesso.",
            trace: null,
          });
          await this.list()
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível atualizar o status das promoções",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    removePromotions(){
      try {
        this.apiService.post('promotion/delete/list', this.selectedPromotions).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Promoções excluídas com sucesso.",
            trace: null,
          });
          await this.list()
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível excluir as promoções",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    addPromotionListSelectedPromotions(promotion){
      const promotionFind = this.selectedPromotions.findIndex((x) => x.id === promotion.id)
      if (promotionFind > -1) {
        this.selectedPromotions.splice(promotionFind, 1)
      } else {
        this.selectedPromotions.push(promotion)
      }
    },

    async getResales() {
      try {
        return await this.apiService.get("resale/list")
      } catch (e) {

      }
    },

    async getProducts() {
      try {
        this.products = await this.apiService.get("product/list/products")
      } catch (e) {

      }
    },

    addResalesPromotion() {
      try {
        this.loading = true;

        this.currentPromotion.resales = this.resales.filter((resale) => resale.checked).map((resale) => resale.id)
        this.currentPromotion.doneByAdminOrMasterUser = true;
        this.apiService.post('promotion/add-resale', this.currentPromotion).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Revendas adicionada a promoção!",
            trace: null,
          });
          await this.list()
          await this.closeResaleAddedPromotionDialog()
          this.loading = false;
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível adicionar as revendas a promoção",
            trace: null,
          });
          this.loading = false;
        })
      } catch (e) {

      }
    },

    deleteResalesPromotion() {
      try {
        this.loading = true;
        const promotion = {
          doneByAdminOrMasterUser: true,
          promotionsToResale: this.resalesDelete.filter((resale) => resale.checked).map((resale) => resale.id)
        }
        this.apiService.post(`promotion/refuse`, promotion).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Revendas excluida da promoção",
            trace: null,
          });
          await this.list()
          await this.closeDeleteResalesDialog()
          this.loading = false;
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível excluir revendas da promoção!",
            trace: null,
          });
          this.loading = false;
        })
      } catch (e) {

      }
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },

    resetFilter() {
      this.filter = {
        name: null,
        discountType: null,
        discountStart: null,
        dateStart: null,
        dateEnd: null,
        discountEnd: null,
        status: null,
        region: null,
        resales: [],
        products: [],
        pageSize: 20,
        page: 1,
        totalPages: 1,
        totalItems: 1,
        currentPage: 1,
      }
      this.list()
    },

    async list() {
      this.loading = true;
      this.apiService.post('promotion/list', this.filter).then((response) => {
        this.items = response.promotions
        this.filter.totalPages = response.pager.totalPages
        this.filter.totalItems = response.pager.totalItems
        this.filter.currentPage = response.pager.currentPage
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },

    async backPage() {
      this.filter.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.list();
    },


    async editPromotion(item) {
      localStorage.setItem("filters", JSON.stringify(this.filter));
      await this.$router.push({
        path: "/promotion?id=" + item.id,
        params: item,
      });
    },

    async showAddResalesDialog(item) {
      this.addResalesDialog = true
      this.currentPromotion = item
      this.loading = true
      this.resales = await this.getResales()
      this.resales = this.resales.filter((x) => !this.currentPromotion.promotionsResale.find((y) => y.resaleId === x.id))
      this.loading = false
    },

    async showshowResaleAddedPromotionDialog(item) {
      this.resalesAddedDialog = true
      this.resaleAddedPromotion = item.promotionsResale
    },

    async showDeleteResalesDialog(item) {
      this.deleteResalesDialog = true
      this.currentPromotion = item
      this.loading = true
      this.resalesDelete = this.currentPromotion.promotionsResale
      this.loading = false
    },

    async closeAddResalesDialog() {
      this.resalesAddedDialog = false
    },

    async closeResaleAddedPromotionDialog() {
      this.addResalesDialog = false
    },

    async closeDeleteResalesDialog() {
      this.deleteResalesDialog = false
    },

    async changeStatus(item) {
      this.loading = true;
      this.apiService
          .put("promotion/active", item)
          .then(async () => {
            this.loading = false;
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "sucsess",
              title: "",
              message: "Status da promoção atualizado com sucesso!",
              trace: null,
            });
            await this.list()
          })
          .catch(() => {
            this.loading = false;
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Não foi possível atualizar o status da promoção!",
              trace: null,
            });
          });
    },

    deletePromotion(item) {
      this.currentPromotion = item.id;
      this.deleteDialog = true;
    },

    async remove() {
      this.loading = true;
      this.deleteDialog = false;
      await this.apiService
          .delete(`promotion/delete?id=${this.currentPromotion}`)
          .then(async () => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "sucsess",
              title: "",
              message: "Promoção excluida com sucesso!",
              trace: null,
            });
            await this.list();
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Não foi possível excluir promoção, verifique os campos e tente novamente!",
              trace: null,
            });
            this.loading = false;
          });
    },
  },

  watch: {
    "filter.page": {
      deep: true,
      async handler() {
        await this.list()
      }
    },
  }
};
</script>

<style scoped>
.update-status {
  width: 110px !important;
  border-radius: 2px !important;
}

.cadaster-button {
  border-radius: 7.5px !important;
  transition: 0.3s;
  background: #bc0000 !important;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
  width: 50%;

}

.cadaster-button:hover {
  color: white !important;
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.cancel-button {
  border-radius: 7.5px !important;
  border: 2px solid #2d3038;
  box-sizing: border-box;
  font-weight: bold;
  transition: 300ms;
  width: 50%;

}

.cancel-button:hover {
  background: #2d3038;
  color: white !important;
}

.cancel-button:focus {
  background: #444854;
  color: white !important;
}


</style>
